import {
  AttachEditState,
  AttachFetchType,
} from '../redux/Attachment/Attachment.type';

export const formatAttachmentsFiles = (
  attachments: AttachEditState[],
): AttachFetchType[] =>
  attachments.map((attach: AttachEditState) => ({
    uuid: attach.uuid,
    tmpUUID: attach.uuid ? undefined : attach.tmpUUID,
    author_id: attach.author_id,
    type: attach.type,
    url: attach.url,
    file: attach.file,
    is_private: attach.isPrivate ? 1 : 0,
    is_deleted: attach.isDeleted ? 1 : 0,
  }));
